import { Field } from 'redux-form';
import { createTextMask, createNumberMask } from 'redux-form-input-masks';

import { SourceInput } from './source-input';

/*
const maxDatePeriod = 3;
const maxDatePeriodType = 'months';

const checkPeriod = (t, name) => (_val, row) => {
  let error = undefined;

  const fn1 = name.split('_');
  if (fn1.length !== 2) {
    return error;
  }
  const fn = fn1[0];
  const fn_from = fn + '_from';
  const fn_to = fn + '_to';
  if (!row[fn_from] || !row[fn_to]) {
    return error;
  }

  const d1 = moment(row[fn_from]);
  const d2 = moment(row[fn_to]);
  if (d2 <= d1) {
    error = t('messages.Дата начала периода больше даты конца периода');
  } else if (d2.subtract(maxDatePeriod, maxDatePeriodType) > d1) {
    error = t('messages.Период не должен превышать три месяца');
  }
  return error;
};
*/

export const FieldComponent = (props) => {
  const { mask, tabIndex, autoFocus, onChange, ...rest } = props;
  // const { t, i18n } = useTranslation();
  // const isDateTime = props.type === 'dateTime' && (props.name?.includes('_from') || props.name?.includes('_to'));
  let textMask = null;
  let numberMask = null;

  switch (typeof mask) {
    case 'string':
      textMask = createTextMask({
        pattern: props.mask,
        stripMask: !props.storeWithMask,
      });
      break;
    case 'object':
      numberMask = createNumberMask({ ...mask, allowNegative: !!rest.withMinus });
      break;
    default:
      break;
  }

  const normalize = (value) => {
    if (props.withoutLetters) {
      return value.replace(/\D/g, '');
    }

    if (value.length > props.maxValueLength) {
      return value.substring(0, value.length - 1);
    } else {
      const fractional = props.fractional;

      if (props.naturalNumber) {
        // zero
        if (props.withZero) {
          if (!value) {
            if (props.EmptyOnExit) {
              return '';
            }
            return 0;
          }
          let out = value.replace(/[^\d]/g, '');
          if (!out.trim()) {
            if (props.EmptyOnExit) {
              return '';
            }
            return 0;
          }
          return parseInt(out);
        }
        // minus
        if (props.withMinus) {
          if (!value) {
            return 0;
          }

          if (fractional) {
            // [+-]?([0-9]*[.])?[0-9]+
            // [+-]?\d+(\,\d+)?
            // const numbers = value.match(/(^[+-]?([0-9]*[,])?[0-9]+$)/g);
            // console.log('🚀 ~ normalize ~ numbers:', numbers);
            // if (!numbers?.length) {
            //   return 0;
            // }
            // const out = numbers[0].replace(',', '.');
            // return out[out.length - 1] === '.' ? out : parseFloat(out);
            return value
              .replace(',', '.')
              .replace(/[^0-9.+-]|(?<=\..*)\./g, '')
              .replace(/^0+/, '0')
              .replace(/^0(?=[1-9])/, '');
          }

          const numbers = value.match(/([+-]?\d+)/g);
          return numbers && numbers.length ? parseInt(numbers[0]) : 0;
        }

        if (!value || /^0+$/g.test(value)) {
          return '';
        } else {
          return value.replace(/[^\d]/g, '').replace(/^0+(?=[1-9])/g, '');
        }
      }

      if (props.withoutSpaces) {
        return value.replace(/[\s]/g, '');
      }

      return value;
    }
  };

  const other = {};
  // const name = props.name;
  // if (isDateTime && !props.validate) {

  //   other.validate = useCallback(checkPeriod(t, name), [t, name]);
  //   other.simpleErrorWrapper = true;
  //   other.asFilter = true;
  // }

  return (
    <Field
      tabIndex={tabIndex}
      autoFocus={autoFocus}
      component={SourceInput}
      additionalComponent={props.additionalComponent}
      className={props.className}
      validate={props.validate}
      Tip={props.tip}
      mask={props.mask}
      name={props.name}
      label={props.label}
      placeholder={props.placeholder}
      type={props.type}
      disabled={props.disabled}
      value={props.value}
      data={props.data}
      normalize={normalize}
      withoutWrapper={props.withoutWrapper}
      maxLength={props.maxLength}
      // need for autocomplete field
      getList={props.getList}
      setAutocompleteList={props.setAutocompleteList}
      requestParams={props.requestParams}
      // need for date field
      withoutIcon={props.withoutIcon}
      // need for zone field
      countDisplayedIcons={props.countDisplayedIcons}
      onChangeInput={onChange}
      onChange={onChange}
      //ref={props.ref}
      //withRef={props.withRef}
      {...textMask}
      {...numberMask}
      {...rest}
      {...other}
    >
      {props.children}
    </Field>
  );
};
